import "react";
import { jsx as e, jsxs as r } from "react/jsx-runtime";
var d = (o) => /* @__PURE__ */ e("svg", {
  fill: "none",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ...o,
  children: /* @__PURE__ */ r("g", {
    stroke: "#00795e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    children: [/* @__PURE__ */ e("path", {
      clipRule: "evenodd",
      d: "m12 21c-4.971 0-9-4.029-9-9 0-4.971 4.029-9 9-9 4.971 0 9 4.029 9 9 0 4.971-4.029 9-9 9z",
      fillRule: "evenodd"
    }), /* @__PURE__ */ e("path", { d: "m16 10-5 5-3-3" })]
  })
});
export {
  d as default
};

//# sourceMappingURL=CheckmarkCircle.js.map